import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IErrorLogEntry } from "../../utils/types/models";

export default createEntityReducer<IErrorLogEntry>(Endpoint.ErrorLog, Endpoint.ErrorLogList);
